<template>
    <div class="index">
        <div class="search-wrap">
            <a @click="goSearch" class="search-link"
                >输入股票代码/首字母查询个股详情</a
            >
        </div>
        <div v-if="dialogVisible" style="background:#e9f0fe;padding: 0.16rem 0.32rem;display: flex;justify-content: space-between;">

            <div style="font-size: 0.24rem;color:#286df7;" @click="gotoTip()">
                {{ dialogText  }}
            </div>
            <div style="color:#333333;font-size: 0.24rem;" @click="dialogVisible = false">
                x
            </div>
        </div>
        <div class="tabs flex">
            <dl
                v-for="(tab, index) in tabs"
                :key="tab.id"
                :class="curTab == index ? tab.class_cur : ''"
                @click="curTab = index"
            >
                <dt>
                    {{ tab.title }}
                    <small>({{ tab.text }})</small>
                    <span
                        class="fr icon-tag"
                        :class="tab.state > 0 ? '' : 'icon-gray'"
                        >{{ tab.jyzt}}</span
                    >
                    <span class="arrow"></span>
                </dt>
                <dd v-if="tab.id == 0" >
                    <!-- 合计净买额
                        <span class="fr" :class="bxzjOldJlrData.jiage_hj | formateRedGreen">{{
                            bxzjOldJlrData.jiage_hj | formatePrefixDataDe
                        }}</span>
                    <br /> -->
                    成交总额
                        <span class="fr" :class="altogether.bx_both_total | formateRedGreen">{{altogether.bx_both_total | formatePrefixDataD}}</span>
                    <!-- 成交总额
                    <span

                        class="fr"
                        :class="altogether.bx_both_total | formateRedGreen"
                    >
                        {{altogether.bx_both_total | formatePrefixDataD}}
                    </span> -->
                    <!-- <span
                        v-else
                        class="fr"
                        :class="altogether.nx_both_total | formateRedGreen"
                    >
                        {{altogether.nx_both_total | formatePrefixData}}
                    </span> -->
                </dd>
                <dd v-else>
                    合计净买额
                        <span class="fr" :class="tab.buyNet | formateRedGreen">{{
                            tab.buyNet | formatePrefixDataS
                        }}</span>
                    <!-- <br />
                    成交总额
                        <span class="fr" :class="tab.buyNet | formateRedGreen">{{altogether.nx_both_total | formatePrefixData}}</span> -->
                </dd>

                <!-- <dd>成交总额<span class="fr" :class="tab.buyNet|formateRedGreen">{{tab.buyNet|formatePrefixData}}</span></dd> -->
            </dl>
        </div>
        <LuGuTong v-if="curTab == 0" />
        <GangGuTong v-if="curTab == 1" />
            <!-- 提示窗口 -->
        <!-- <div :class="dialogVisible?'dialog-six-mask':'dialog-six-hidden'" @click="closeDialog">
            <div class="dialog-six long-dialog"  @click.stop="">
                <div class="dialog-six-title">
                    说明
                </div>
                <div class="dialog-six-content">
                    <p style="white-space:pre-line;">{{dialogContent}}</p>
                </div>
                <div class="dialog-six-footer">
                    <span class="btn-gray" @click="closeDialog">关闭</span>
                    <span @click="closeDialog">查看详情</span>
                </div>
            </div>
        </div> -->

    </div>
</template>

<script>
import LuGuTong from "@/components/LuGuTong.vue";
import GangGuTong from "@/components/GangGuTong.vue";

import { gkInfo } from "@/api/index.js";
import { becomeTotal } from "@/api/index.js";
import { bxzjOldJlr } from "@/api/lszx.js";

import { share } from "@/lib/dzh";
import wxshare from "@/assets/js/wxshare";

export default {
    name: "indexPage",
    components: {
        LuGuTong,
        GangGuTong,
    },
    data() {
        return {
            //老版本净流入
            isday:0,
            bxzjOldJlrData: {},
            // 成交总额和额度余额
            altogether:{
                bx_both_total:0,
                nx_both_total:0,
                bx_h_bsTotal: 0,
                bx_h_saleTotal: 0,
                bx_s_bsTotal: 0,
                bx_s_saleTotal: 0,
                nx_h_bsTotal: 0,
                nx_h_saleTotal: 0,
                nx_s_bsTotal: 0,
                nx_s_saleTotal: 0
            },
            // buyNet:'',
            dialogVisible: false, // 弹窗显示
            dialogContent: '2024年月日起，上交所、深交所、港交所对沪深港通交易信息披露机制进行调整，具体如下：\n1、沪深方面，不再波露实时买入交易金额、卖出交易金额和交易总额；当日额度厼额大于或等于30％时，显衣额度充足过小于30％时，实时公布额应余额。\n2、港股方面，当日额度厼额大于或等于30％时，显示"额度充足。；小于30％时，实时公布额度余额。其余港股通信息披露保持不变·',
            dialogText:'',
            curTab: 0,
            tabs: [
                {
                    id: 0,
                    title: "陆股通",
                    text: "北向",
                    state: -1,
                    buyNet: null,
                    jyzt:'已结束',
                    class_cur:'cur cur-gray',
                },
                {
                    id: 1,
                    title: "港股通",
                    text: "南向",
                    state: -1,
                    buyNet: null,
                    jyzt:'已结束',
                    class_cur:'cur cur-gray',
                },
            ],
        };
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixDataDe: function (v) {

            if(v==undefined||v==null|| v == '--'|| v == '----' || v== 0){
                return '待更新';
            } else if(v>0){
                return '+'+v+'亿';
            } else if(v<0){
                return v +'亿';
            }else{
                return v;
            }

        },
        formatePrefixDataS: function (v) {
            if (v == undefined || v == null || v =='--') return "--";
            if (v > 0) return "+" + v + "亿";
            if (v <= 0) return v + "亿";
            // if(v==undefined||v==null || v == '--'|| v == '----' || v == 0){
            //     return '--';
            // } else if(v>0){
            //     return '+'+(v/100000000).toFixed(2)+'亿';
            // } else if(v<0){
            //     return (v/100000000).toFixed(2) +'亿';
            // }else{
            //     return v;
            // }

        },
        formatePrefixData: function (v) {
            // if (v == undefined || v == null || v =='--') return "--";
            // if (v > 0) return "+" + v + "亿";
            // if (v <= 0) return v + "亿";
            if(v==undefined||v==null || v == '--'|| v == '----' || v == 0){
                return '--';
            } else if(v>0){
                return (v/100000000).toFixed(2)+'亿';
            } else if(v<0){
                return (v/100000000).toFixed(2) +'亿';
            }else{
                return v;
            }

        },
        formatePrefixDataD: function (v) {
            // if (v == undefined || v == null || v =='--') return "--";
            // if (v > 0) return "+" + v + "亿";
            // if (v <= 0) return v + "亿";
            if(v==undefined||v==null || v == '--'|| v == '----' || v == 0){
                return '待更新';
            } else if(v>0){
                return (v/100000000).toFixed(2)+'亿';
            } else if(v<0){
                return (v/100000000).toFixed(2) +'亿';
            }else{
                return v;
            }

        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
    },
    created() {
        if(this.$route.query.nav==0){
            this.curTab = 0;
        }
        if(this.$route.query.nav==1){
            this.curTab = 1;
        }
        wxshare.do(
            this.$route.fullPath,
            "http://static.yundzh.com/logo.png",
            "沪深港通"
        );
    },
    mounted: function () {
        this.getLssjJlr();
        this.getInfo();
        this.getBecomeTotal();
        document.title = "沪深港通";
        share("沪深港通", this.$route.fullPath);
        if(history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
        // 首次判断
        this.checkFirst();

        // 判断提示信息是否展示
        const timestamp = new Date().getTime();

        const abort_timestamp = new Date(window.top_abort_date).getTime();

        if(timestamp > abort_timestamp){
            this.dialogVisible = false;
        }else{
            this.dialogText = window.top_abort_text;
            this.dialogVisible = true;
        }
    },
    methods: {
        // 获取老版本净流入额  8月份可能不下发
        getLssjJlr: function () {
            var _this = this;
            var params = {
                'page':'1',
                'size':'1',
            }
            bxzjOldJlr(params).then((res) => {
                _this.isday = res.data.data.isDay;

                if (res.data.err == 0 && res.data.data.isDay != undefined && res.data.data.list.length > 0) {

                    if(_this.isday == 0){
                        res.data.data.list[0].jiage_hj = '0';
                        res.data.data.list[0].jiage_h = '0';
                        res.data.data.list[0].jiage_s = '0';
                        _this.bxzjOldJlrData = res.data.data.list[0];
                    }else{
                        _this.bxzjOldJlrData = res.data.data.list[0];
                    }

                    this.$store.commit('updateOldJlr', _this.bxzjOldJlrData);

                }
            });
        },
        // 获取合计净买入
        getInfo() {
            gkInfo().then((res) => {
                // console.log(res);
                if (res.data.err == 0) {
                    // 北向资金
                    if(res.data.data.SHHK.hgt.jyzt == '额度可用') {
                        this.tabs[0].jyzt = '交易中';
                        this.tabs[0].state = 1;
                    }else{
                         this.tabs[0].jyzt = res.data.data.SHHK.hgt.jyzt;
                         this.tabs[0].state = -1;
                    }
                    if(res.data.data.SHHK.hgt.zjlx != '--' && res.data.data.SZHK.sgt.zjlx != '--'){
                        this.tabs[0].buyNet = (
                            (res.data.data.SHHK.hgt.zjlx +
                                res.data.data.SZHK.sgt.zjlx) /
                            100000000
                        ).toFixed(2);
                    }

                    // 南向资金
                    if(res.data.data.SHHK.ggt_h.jyzt == '额度可用') {
                        this.tabs[1].jyzt = '交易中';
                        this.tabs[1].state = 1;
                    }else{
                         this.tabs[1].jyzt = res.data.data.SHHK.ggt_h.jyzt;
                         this.tabs[1].state = -1;
                    }

                    if(res.data.data.SHHK.ggt_h.zjlx != '--' && res.data.data.SZHK.ggt_s.zjlx != '--'){
                        this.tabs[1].buyNet = (
                            (res.data.data.SHHK.ggt_h.zjlx +
                                res.data.data.SZHK.ggt_s.zjlx) /
                            100000000
                        ).toFixed(2);

                    }
                    this.$store.commit('updateJyzt', this.tabs[0].jyzt);

                    // // 背景色-北
                    // if (this.tabs[0].buyNet>0) {
                    //     this.tabs[0].class_cur = 'cur cur-red';
                    // } else if(this.tabs[0].buyNet<0) {
                    //     this.tabs[0].class_cur = 'cur cur-green';
                    // }else{
                    //     this.tabs[0].class_cur = 'cur cur-gray';
                    // }

                    // // 背景色-南
                    // if (this.tabs[1].buyNet>0) {
                    //     this.tabs[1].class_cur = 'cur cur-red';
                    // } else if(this.tabs[1].buyNet<0) {
                    //     this.tabs[1].class_cur = 'cur cur-green';
                    // }else{
                    //     this.tabs[1].class_cur = 'cur cur-gray';
                    // }
                }

                // if (res.data.err == 0) {
                //     if (res.data.data.SHHK.hgt.jyzt !== "--") {
                //         this.tabs[0].state = -1;
                //         this.tabs[0].buyNet = null;
                //     } else {
                //         this.tabs[0].state = 1;
                //         this.tabs[0].buyNet = (
                //             (res.data.data.desc.hgt_jlr +
                //                 res.data.data.desc.sgt_jlr) /
                //             100000000
                //         ).toFixed(2);
                //     }
                //     if (res.data.data.SHHK.ggt_h.jyzt !== "--") {
                //         this.tabs[1].state = -1;
                //         this.tabs[1].buyNet = null;
                //     } else {
                //         this.tabs[1].state = 1;
                //         this.tabs[1].buyNet = (
                //             (res.data.data.desc.ggt_h_jlr +
                //                 res.data.data.desc.ggt_s_jlr) /
                //             100000000
                //         ).toFixed(2);
                //     }
                // } else {
                //     console.log(456);
                // }
            });
        },
        // 获取成交总额和额度余额
        getBecomeTotal() {
            becomeTotal().then((res) => {
                if (res.data.err == 0) {
                    this.altogether = res.data.data
                    this.$store.commit('updateAltogether', res.data.data);

                    // 背景色-北
                    if ((this.altogether.bx_s_bsTotal + this.altogether.bx_h_bsTotal) > 0) {
                        this.tabs[0].class_cur = 'cur cur-red';
                    } else if((this.altogether.bx_s_bsTotal + this.altogether.bx_h_bsTotal) < 0) {
                        this.tabs[0].class_cur = 'cur cur-green';
                    }else{
                        this.tabs[0].class_cur = 'cur cur-gray';
                    }

                    // 背景色-南

                    if ((this.altogether.nx_s_bsTotal + this.altogether.nx_h_bsTotal) > 0) {
                        this.tabs[1].class_cur = 'cur cur-red';
                    } else if((this.altogether.nx_s_bsTotal + this.altogether.nx_h_bsTotal) < 0) {
                        this.tabs[1].class_cur = 'cur cur-green';
                    }else{
                        this.tabs[1].class_cur = 'cur cur-gray';
                    }

                    // console.log(this.tabs,'this.altogether.nx_s_bsTotal');
                }

            });
        },
        // 跳转到搜索页
        goSearch: function () {
            this.$router.push("/search");
        },
        /**
         * 首次访问
         */
        checkFirst(){
            var is_first=localStorage.getItem('ggt-first');
            // console.log("is_first:",is_first);
            if (!is_first) {
                // this.showDialog();
                // 解开注释显示一次后就不再显示
                // localStorage.setItem('ggt-first',1);
            }
        },
        /*弹窗显示*/
        showDialog() {
            this.dialogVisible = true;
        },
        /*弹窗关闭*/
        closeDialog() {
            this.dialogVisible = false;
        },
        gotoTip(){
            location.href=window.topUrl
        },

    },
};
</script>
